export { default as Img200 } from './processed/200/LadiesinLavender-448x252.jpg';
export { default as Img400 } from './processed/400/LadiesinLavender-448x252.jpg';
export { default as Imgthumb } from './processed/thumb/LadiesinLavender-448x252.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/LadiesinLavender-448x252.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/LadiesinLavender-448x252.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      206,
      126,
      36
    ],
    "_population": 3,
    "_hsl": [
      0.08823529411764706,
      0.7024793388429753,
      0.4745098039215686
    ]
  },
  "LightVibrant": {
    "_rgb": [
      242,
      206,
      111
    ],
    "_population": 54,
    "_hsl": [
      0.12086513994910943,
      0.8343949044585987,
      0.692156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      125,
      33,
      28
    ],
    "_population": 59,
    "_hsl": [
      0.008591065292096226,
      0.6339869281045751,
      0.3
    ]
  },
  "Muted": {
    "_rgb": [
      95,
      87,
      157
    ],
    "_population": 1051,
    "_hsl": [
      0.6857142857142856,
      0.28688524590163933,
      0.47843137254901963
    ]
  },
  "LightMuted": {
    "_rgb": [
      192,
      157,
      179
    ],
    "_population": 899,
    "_hsl": [
      0.8952380952380953,
      0.21739130434782603,
      0.6843137254901961
    ]
  },
  "DarkMuted": {
    "_rgb": [
      80,
      62,
      116
    ],
    "_population": 441,
    "_hsl": [
      0.7222222222222222,
      0.30337078651685395,
      0.34901960784313724
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/LadiesinLavender-448x252.js